// @ts-nocheck
import {Column} from 'react-table'
import { useIntl } from 'react-intl';
import { BookingExtra } from '../../core/_models';
import { BookingExtraCustomHeader } from './BookingExtraCustomHeader';
import { BookingExtraActionsCell } from './BookingExtraActionsCell';

const bookingExtrasColumns: ReadonlyArray<Column<BookingExtra>> = [
  {
    Header: (props) => (
      <BookingExtraCustomHeader
        tableProps={props}
        title={useIntl().formatMessage({ id: 'COLUMNS.NAME' })}
        className='min-w-125px'
      />
    ),
    id: 'translations[0].title',
    Cell: ({ row }) => (
      <span>{row.original.translations?.[0]?.title}</span>
    ),
  },
  {
    Header: (props) => (
      <BookingExtraCustomHeader
        tableProps={props}
        title={useIntl().formatMessage({ id: 'COLUMNS.TYPE' })}
        className='min-w-100px'
      />
    ),
    id: 'type',
    Cell: ({ row }) => <span>{row.original.type}</span>,
  },
  {
    Header: (props) => (
      <BookingExtraCustomHeader
        tableProps={props}
        title={useIntl().formatMessage({ id: 'COLUMNS.CATEGORY' })}
        className='min-w-100px'
      />
    ),
    id: 'category',
    Cell: ({ row }) => <span>{row.original.category || '-'}</span>,
  },
  {
    Header: (props) => (
      <BookingExtraCustomHeader
        tableProps={props}
        title={useIntl().formatMessage({ id: 'COLUMNS.ORDER' })}
        className='min-w-75px'
      />
    ),
    id: 'order',
    Cell: ({ row }) => <span>{row.original.order ?? 0}</span>,
  },
  {
    Header: (props) => (
      <BookingExtraCustomHeader tableProps={props} title='' className='text-end min-w-100px' />
    ),
    id: 'actions',
    Cell: ({...props}) => <BookingExtraActionsCell id={props.data[props.row.index]._id} />,
  },
]

export {bookingExtrasColumns}
